import { useEffect, useState } from 'react';
import { useJsApiLoader } from '@react-google-maps/api';
import { GMAPS_LIBRARIES } from '@util/customHooks/useLocationToGeoCode';

export const useStreetViewAvailability = (streetViewData) => {
  const config = {
    google: {
      mapKey: process.env.NEXT_PUBLIC_GOOGLE_MAP_KEY!,
    },
  };

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: config.google.mapKey,
    libraries: GMAPS_LIBRARIES,
  });

  const [isStreetViewAvailable, setIsStreetViewAvailable] = useState(false);

  useEffect(() => {
    if (isLoaded) {
      const sv = new google.maps.StreetViewService();
      sv.getPanorama({ location: streetViewData, radius: 50 }, (data, status) => {
        if (status === google.maps.StreetViewStatus.OK) {
          setIsStreetViewAvailable(true);
        } else {
          setIsStreetViewAvailable(false);
        }
      });
    }
  }, [isLoaded, streetViewData]);

  return isStreetViewAvailable;
};
